import React from "react";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { services } from "../../mock";
import SectionLabel from "./SectionLabel";
import Reveal from "./Reveal";

const ServiceCard = ({ s }) => {
  const Icon = Icons[s.icon] || Icons.Dumbbell;
  return (
    <div className="group relative border-t border-white/10 pt-8 pb-8 px-1 md:px-2 transition-colors duration-500 hover:border-white/40">
      <div className="flex items-start justify-between">
        <Icon size={30} strokeWidth={1.4} className="text-white" />
        <div className="flex items-start gap-4">
          <span className="font-mono-label text-[11px] text-white/35">{s.num}</span>
          <ArrowUpRight
            size={18}
            className="text-white/40 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-white"
          />
        </div>
      </div>
      <h3 className="font-display text-2xl md:text-[26px] text-white mt-14 normal-case" style={{ textTransform: "none", letterSpacing: "-0.01em" }}>
        {s.title}
      </h3>
      <p className="text-white/60 text-sm md:text-[15px] leading-relaxed mt-5">{s.text}</p>
      <div className="font-mono-label text-[10px] text-white/40 mt-10">{s.tag}</div>
    </div>
  );
};

const Services = () => {
  return (
    <section id="servizi" className="bg-[#0c0c0d] border-y border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <SectionLabel>I nostri servizi</SectionLabel>

        <div className="grid md:grid-cols-2 gap-8 md:gap-16 mt-8 items-end">
          <h2 className="font-display text-4xl md:text-7xl text-white">
            Tutto ciò di cui hai bisogno per{" "}
            <span style={{ fontStyle: "italic", fontWeight: 800 }} className="text-white/45">
              migliorare.
            </span>
          </h2>
          <p className="text-white/60 text-base md:text-lg leading-relaxed">
            Una proposta integrata: allenamento, nutrizione, recupero. Niente di più, niente di
            meno. Lavoriamo solo con metodo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 md:gap-x-16 mt-16">
          {services.map((s, i) => (
            <Reveal key={s.num} delay={(i % 3) * 90}>
              <ServiceCard s={s} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
